import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FieldType } from '../../../core';
var FormlyFieldRadio = (function (_super) {
    tslib_1.__extends(FormlyFieldRadio, _super);
    function FormlyFieldRadio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldRadio;
}(FieldType));
FormlyFieldRadio = tslib_1.__decorate([
    Component({
        selector: 'formly-field-radio',
        template: "\n    <div [formGroup]=\"form\">\n      <div *ngFor=\"let option of to.options\" class=\"radio\">\n        <label class=\"custom-control custom-radio\">\n          <input [name]=\"id\" type=\"radio\" [value]=\"option.key\" [formControl]=\"formControl\"\n          [formlyAttributes]=\"field\" class=\"custom-control-input\">\n          {{ option.value }}\n          <span class=\"custom-control-indicator\"></span>\n        </label>\n      </div>\n    </div>\n  ",
    })
], FormlyFieldRadio);
export { FormlyFieldRadio };
//# sourceMappingURL=radio.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/radio.js
// module id = 775
// module chunks = 3